import { takeLatest } from "redux-saga/effects";
import { FETCH_VACATION_RENTAL_SHOP } from "../actions/constants";
import { fetchVacationRentalShopSaga } from "./fetchVacationRentalShopSaga";

export function* watchFetchVacationRentalShopSaga() {
  yield takeLatest(FETCH_VACATION_RENTAL_SHOP, fetchVacationRentalShopSaga);
}
